import { get } from 'app/shared/utils/fetchr';
import { SessionAgent } from 'app/modules/session/models';

const ORGS_API_BASE = '/orgs';

export const getOrgAgents = (orgId: number): Promise<SessionAgent[]> => {
  return get(`${ORGS_API_BASE}/${orgId}/agents`);
};
